import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceRouter } from '@pershing/pershing-core';
import { Observable } from 'rxjs';
import { NXIMISCServiceDefinition } from './nxi-misc-service.definition';

@Injectable()
export class ModernNavigationService  {
    public miscServiceUrl: string;
    constructor(private http: HttpClient, private serviceRouter: ServiceRouter) {
        this.miscServiceUrl = this.serviceRouter.getServiceRouteURL(NXIMISCServiceDefinition.getInstance());
    }

    getFinancialAdvisorData(reqBody): Observable<any> {
        return this.http.post(this.miscServiceUrl + '/miscservice/advisordetails', reqBody);
    }
}
